import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Util from '@/common/utils/Util'

Vue.use(Router)
import Sign from '@/pages/account/sign'
import Login from '@/pages/account/login'
import findID from '@/pages/account/findID'
import findPWD from '@/pages/account/findPWD'
import Index from '@/pages/index'
import Report from '@/pages/elect/report'
import ReportDetail from '@/pages/elect/reportDetail'
import ReportDetailLow from '@/pages/elect/reportDetailLow'
import Cert from '@/pages/cert'

/**
 * header, footer와 같은 layout 상태 update
 * @param meta.isFooter {Boolean} footer show 여부
 * @param meta.isHeader {Boolean} header show 여부
 * @param meta.titleName {String} header title String
 * @param meta.isMain {Boolean} main header show 여부
 *
 * */

let nowPath = ''
let closePaths = ['/', '/account/login', '/comm/wait', '/parent/main', '/parent/scheduleList', '/normal/main', '/normal/scheduleList', '/comm/mypage']

const router = new Router({
  linkActiveClass: 'on',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (!(to.path === '/findID' || to.path === '/findPWD')) {
      return {x: 0, y: 0, behavior: 'auto'}
    }
  },
  routes: [
    {
      path: '/',
      component: Index
    },
    {
      path: '/account/sign',
      component: Sign
    },
    {
      path: '/account/login',
      component: Login
    },
    {
      path: '/account/findID',
      component: findID
    },
    {
      path: '/account/findPWD',
      component: findPWD
    },
    {
      path: '/elect/report',
      component: Report,
      beforeEnter: function (to, from, next) {
        const userData = store.getters['account/getUserData']
        if (Util.isEmpty(userData)) {
          return next('/')
        }

        return next()
      }
    },
    {
      path: '/elect/reportDetail',
      component: ReportDetail,
      beforeEnter: function (to, from, next) {
        const userData = store.getters['account/getUserData']
        if (Util.isEmpty(userData)) {
          return next('/')
        }

        return next()
      }
    },
    {
      path: '/elect/reportDetailLow',
      component: ReportDetailLow,
      beforeEnter: function (to, from, next) {
        const userData = store.getters['account/getUserData']
        if (Util.isEmpty(userData)) {
          return next('/')
        }

        return next()
      }
    },
    {
      path: '/cert',
      component: Cert,
      beforeEnter: function (to, from, next) {
        const userData = store.getters['account/getUserData']
        if (Util.isEmpty(userData)) {
          return next('/')
        }

        return next()
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.fromPath = from.fullPath
  window.toPath = to.fullPath
  let meta = to.meta
  // updateLayout(meta)
  nowPath = to.fullPath

  return next()
})

export default router
